import {
  httpTokenCommon,
  httpTokenFileDownload,
  httpTokenFileUpload,
} from "../helper/http-common";
import {
  addBudgetFormData,
  getAdminDashboardData,
  getPolicyDashboardData,
  getReImagingDashboardData,
} from "../types/adminSection";

class AdminServices {
  //// R and R Dashboard API
  getAdminDashboardCard(inputData: getAdminDashboardData) {
    return httpTokenCommon.post(
      "RewardAndRecognization/getDashboardCount",
      inputData
    );
  }
  getRandRADashboardData(inputData: getAdminDashboardData) {
    return httpTokenCommon.post(
      "RewardAndRecognization/getDashboardData",
      inputData
    );
  }

  getSearchUser(inputData: { searchTerm: string }) {
    return httpTokenCommon.post("/User/search", inputData);
  }
  RRDashboardExport(input: getAdminDashboardData) {
    return httpTokenFileDownload.post("RewardAndRecognization/Export", input, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  //// REImagine Dashboard API
  getREImagineDashboardCard(inputData: getReImagingDashboardData) {
    return httpTokenCommon.post("REImagine/getDashboardCount", inputData);
  }
  getREImagineDashboardData(inputData: getReImagingDashboardData) {
    return httpTokenCommon.post("REImagine/getDashboardData", inputData);
  }
  ReImagineDashboardExport(input: getReImagingDashboardData) {
    return httpTokenFileDownload.post("REImagine/Export", input, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  GetBudgetTableData(inputData: addBudgetFormData) {
    return httpTokenCommon.post("RRBudget/get", inputData);
  }

  addBudgetDataAPI(payload: addBudgetFormData) {
    return httpTokenCommon.post("RRBudget/add", payload);
  }
  updateBudgetDataAPI(payload: addBudgetFormData) {
    return httpTokenCommon.put("RRBudget/update", payload);
  }
  deleteBudgetAPI(Id: number) {
    return httpTokenCommon.delete(`RRBudget/delete/${Id}`);
  }
  BudgetTableExport(input: addBudgetFormData) {
    return httpTokenFileDownload.post("RRBudget/export", input, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  getPolicyDashboardData(inputData: getPolicyDashboardData) {
    return httpTokenCommon.post("Policy/getDashboardData", inputData);
  }

  addPolicyDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("Policy/add", formData);
  }
  updatePolicyDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("Policy/update", formData);
  }
  deletePolicyAPI(Id: number) {
    return httpTokenCommon.delete(`Policy/delete/${Id}`);
  }
}

const adminServices = new AdminServices();
export default adminServices;
